<div class="content content-height">
    <nz-list class="list" [nzLoading]="loading">
        <nz-list-item
            class="item"
            *ngFor="let o of orchestrators"
            [routerLink]="o?.snap?.id"
        >
            <ng-container *ngIf="o !== undefined">
                <span
                    class="icon"
                    nz-icon
                    [nzType]="
                        o.data.State.State !== 'Finished'
                            ? 'sync'
                            : o.data.Result?.Status === 'Failed'
                            ? 'warning'
                            : 'check-circle'
                    "
                    [nzSpin]="o.data.State.State !== 'Finished'"
                ></span>
                <nz-list-item-meta
                    nzDescription="{{ o.snap.id }} {{
                        o.data.State.LastUpdateTime | fsTimestamp
                    }}"
                >
                    <nz-list-item-meta-title
                        >{{ o.data.State.State }}:
                        {{ o.data.Result?.Status || "unknown" }},
                        {{ o.data.Options.Type }}:
                        {{
                            o.data.Options.Type === "Period"
                                ? o.data.Options.Period
                                : o.data.Options.Selection
                        }}</nz-list-item-meta-title
                    >
                </nz-list-item-meta>
                <ul nz-list-item-actions>
                    <nz-list-item-action
                        ><a (click)="copyFirestoreLink(o)"
                            >Copy Firestore link</a
                        ></nz-list-item-action
                    >
                </ul>
            </ng-container>
            <nz-skeleton
                *ngIf="o === undefined"
                [nzAvatar]="true"
                [nzActive]="true"
                [nzTitle]="false"
                [nzLoading]="true"
            ></nz-skeleton>
        </nz-list-item>
        <div class="btnLoad" nz-list-load-more>
            <button nz-button *ngIf="!loading" (click)="loadMoreData()">
                Load older data
            </button>
        </div>
    </nz-list>
</div>
